import React, { useEffect, useRef, useState } from 'react';
import ShareIcon from '@mui/icons-material/Share';
import { CommentsCommponent } from './CommentsCommponent';
import 'react-datepicker/dist/react-datepicker.css';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import TextsmsIcon from '@mui/icons-material/Textsms';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetActionsData_action,
  GetALL_Comments_For_User,
  InsertNewAction_action,
} from '../Redux/Actions/Action_action';
import { Notify } from '../Utility/Notify';
import CircularProgress from '@mui/material/CircularProgress';

//leed preview
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

//icons for leed dialog
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import HistoryIcon from '@mui/icons-material/History';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import ManIcon from '@mui/icons-material/Man';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

//comment dialog
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt';
import NotesIcon from '@mui/icons-material/Notes';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment'; // لاستخدامه في تنسيق التاريخ
import CachedIcon from '@mui/icons-material/Cached';
import InfoIcon from '@mui/icons-material/Info';
import { UpdateClientAction } from '../Redux/Actions/UsersAction';
import RefreshIcon from '@mui/icons-material/Refresh';
import { AllCommentsCommponentMainShow } from './AllCommentsCommponentMainShow';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

//=============================================================================================

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export const ShowAllCommentsForoneuser = ({ user, leadid }) => {
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const [userlogin, setuserlogin] = useState('');

  //user login
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setuserlogin(user);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
    setIsChecked(false);
  };
  const handleShow = () => setShow(true);

  // console.log(userlogin,"userloginrealy")
  //get all data of selected leed
  const getallactiondata = async () => {
    await dispatch(GetALL_Comments_For_User(userlogin?.data?.email || null));
  };

  const [isReady, setIsReady] = useState(false);
  const [comments, setComments] = useState([]);

  useEffect(() => {
    let timeout;
    if (show) {
      setIsReady(false); // تأكد إن `isReady` يبدأ كـ false
      setComments([]); // تفريغ التعليقات قبل جلب البيانات الجديدة

      timeout = setTimeout(async () => {
        await getallactiondata();

        setIsReady(true); // يتم تفعيل `isReady` بعد انتهاء الـ setTimeout
      }, 1500);
    }

    return () => clearTimeout(timeout); // إلغاء المؤقت في حالة إغلاق العنصر قبل الوقت المحدد
  }, [show]);

  const resgetallactions = useSelector((state) => state.AllActions.onseuseraction);

  // تحديث حالة التعليقات بعد جلب البيانات
  useEffect(() => {
    if (Array.isArray(resgetallactions?.data)) {
      const filteredData = resgetallactions.data.filter((item) => item.leed?._id === leadid);
      setComments(filteredData);
    }
  }, [resgetallactions, leadid]);
  //============================================================================

  // let comments = resgetallactions?.data || [];

  // // جلب البيانات اتوماتيك من غير ماعمل ريفريش
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     getallactiondata();
  //   }, 120000); // 2 دقيقة

  //   return () => clearInterval(interval);
  // }, [comments]);

  // جلب البيانات اتوماتيك من غير ماعمل ريفريش
  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        await getallactiondata();
      } catch (error) {
        console.error('❌ Error fetching data:', error);
      }
    }, 360000); // 6 دقيقة

    return () => clearInterval(interval);
  }, [leadid]);

  //==================================================================
  const [firstcomment, setfirstcomment] = useState('');
  const [secondcomment, setsecondcomment] = useState('');
  const [startDateTime, setStartDateTime] = useState('');
  // const [takedate, settakedate] = useState('');

  const [loading, setloading] = useState(true);
  const [sendloading, setsendloading] = React.useState(false);

  const onfirstcommentchange = (e) => {
    setfirstcomment(e.target.value);
  };

  const onsecondcommentchange = (e) => {
    setsecondcomment(e.target.value);
  };

  //date
  //===========================================================
  const [date, setDate] = useState('');
  const [dateonly, setDateonly] = useState('');

  useEffect(() => {
    //date and time
    const today = new Date();
    const formattedDateandtime = today.toLocaleDateString(); // يمكنك تخصيص التنسيق هنا
    setDate(formattedDateandtime);

    //date only
    const todaydayonly = new Date();
    // تنسيق التاريخ: yyyy-MM-dd
    const formattedDateonly = `${todaydayonly.getFullYear()}-${(todaydayonly.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${todaydayonly.getDate().toString().padStart(2, '0')}`;
    setDateonly(formattedDateonly); // تخزين التاريخ في الـ state
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const today = new Date();
      setDate(today.toLocaleDateString());
    }, 86400000); // 86400000 مللي ثانية = 24 ساعة

    return () => clearInterval(interval); // تنظيف
  }, []);

  //==============================================================

  const [valuedate, setvaluedate] = useState(new Date());
  const formattedDate = moment(valuedate).format('M/D/YYYY h:mm A');
  const handleChange = (date) => {
    setvaluedate(date);
  };
  // useEffect(()=>{
  // settakedate(startDateTime)
  // },[startDateTime])

  //on submit data
  const onsubmitdata = async (e) => {
    e.preventDefault();

    if (!firstcomment.trim()) {
      Notify('error', 'Please enter first comment', 'error');
      return;
    }
    if (!secondcomment.trim()) {
      Notify('error', 'Please enter second comment', 'error');
      return;
    }
    if (!valuedate) {
      Notify('error', 'Please select a date', 'error');
      return;
    }

    setloading(true);
    setsendloading(true);
    try {
      // ✅ تنفيذ `InsertNewAction_action` والانتظار حتى ينتهي
      const actionResponse = await dispatch(
        InsertNewAction_action({
          sales: userlogin.data._id,
          text1: firstcomment,
          text2: secondcomment,
          date: valuedate,
          leed: user._id,
          username: userlogin.data._id,
          commentbysales: userlogin.data.name,
          stage: user?.stage?._id,
        }),
      );

      if (!actionResponse || actionResponse.error) {
        throw new Error('Failed to insert new action');
      }

      // ✅ بعد نجاح `InsertNewAction_action`، نقوم بتحديث العميل
      await dispatch(
        UpdateClientAction(user._id, {
          lastcommentdate: dateonly,
        }),
      );

      Notify('success', 'Data submitted successfully!', 'success');
    } catch (error) {
      console.error('Error submitting data:', error);
      Notify('error', 'Failed to submit data. Please try again.', 'error');
    } finally {
      setloading(false);
      setsendloading(false);
    }
  };

  const resaddcomment = useSelector((state) => state.AllActions.AddAction);
  // const resgetdataleads=useSelector(state=>state.Allusers.Get_users)

  useEffect(() => {
    if (loading === false) {
      if (resaddcomment && resaddcomment.data.status === 'success') {
        Notify('success', 'Comments added successfully', 'success');
        setfirstcomment('');
        setsecondcomment('');
        getallactiondata();
        //  setTimeout(() => { window.location.reload(false) }, 1500)
      } else {
        Notify('error', 'Failed to add comments', 'error');
        return;
      }
    }
  }, [loading]);

  //=======================================================================

  //==================================================================
  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  //=================================================================

  //leed preview dialog
  const [open, setOpen] = React.useState(false);

  const handleClickOpenleed = () => {
    setOpen(true);
  };

  const handleCloseleed = () => {
    setOpen(false);
  };

  //full screen dialog
  const [openfullscreen, setOpenfullscreen] = React.useState(false);

  const handleClickOpen = () => {
    setOpenfullscreen(true);
  };

  const handleClosefullscreen = () => {
    setOpenfullscreen(false);
  };

  const divRef = useRef(null); // مرجع لحفظ العنصر
  const cursorPosition = useRef(0); // حفظ موضع المؤشر

  const saveCursorPosition = () => {
    const selection = window.getSelection();
    if (!selection.rangeCount) return;
    const range = selection.getRangeAt(0);
    cursorPosition.current = range.startOffset; // حفظ موضع المؤشر
  };

  const restoreCursorPosition = () => {
    const selection = window.getSelection();
    const range = document.createRange();
    if (divRef.current.childNodes.length > 0) {
      range.setStart(divRef.current.childNodes[0], cursorPosition.current);
      range.setEnd(divRef.current.childNodes[0], cursorPosition.current);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  };

  const onPopupChange = (e) => {
    saveCursorPosition(); // حفظ موضع المؤشر قبل التحديث
    setsecondcomment(e.target.innerText); // تحديث النص
    setTimeout(restoreCursorPosition, 0); // استعادة الموضع بعد التحديث
  };

  // const onFirstCommentChange = (e) => {
  //   setfirstcomment(e.target.value);
  // };

  const onPopupfirstcommentchangeChange = (e) => {
    setfirstcomment(e.target.innerText);
  };

  // check for confirm recieve lead from sales but this role on all user except admin and marketer
  const isClickable =
    user.assign !== true ||
    user?.sales?.userlog === userlogin?.data?._id ||
    userlogin?.data?.role === 'Admin' ||
    userlogin?.data?.role === 'Marketer';

  return (
    <div>
      <Offcanvas
        placement="end"
        show={show}
        onHide={handleClose}
        style={{ width: '900px', background: '#323232' }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ color: 'white', textAlign: 'center', width: '100%' }}>
            <div style={{ fontSize: '20px', fontWeight: 'bold' }}>Actions</div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div style={{ marginTop: '5px' }}>
            <hr />

            {/* //======================================================================== */}
            {/* //show leed data  */}

            <Dialog
              open={open}
              TransitionComponent={Transition}
              keepMounted
              onClose={handleCloseleed}
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle>{'Leed Preview'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  <div
                    className="d-flex w-100 flex-wrap"
                    style={{
                      width: '100%',
                      border: '2px solid white',
                      borderRadius: '10px',
                      color: 'royalblue',
                      backgroundColor: '#e9ebf0',
                    }}
                  >
                    <div className="w-100 my-1 mx-3">
                      <ManIcon /> Leed Name :{user.name}
                    </div>
                    <div className="w-100 my-1 mx-3">
                      <PhoneIphoneIcon /> Mobile :+{user.phone}
                    </div>
                    <div className="w-100 my-1 mx-3">
                      <AlternateEmailIcon /> Email :{user && user.email ? user.email : null}
                    </div>
                    <div className="w-100 my-1 mx-3">
                      <HomeWorkIcon /> Project :
                      {user.project && user.project.name ? user.project.name : null}
                    </div>
                    <div className="w-100 my-1 mx-3">
                      <HomeWorkIcon /> Developer :
                      {user.project && user.project.developer ? user.project.developer.name : null}
                    </div>
                    <div className="w-100 my-1 mx-3">
                      <FolderSharedIcon /> Salesman :{user.sales ? user.sales.name : null}
                    </div>
                    <div className="w-100 my-1 mx-3">
                      <TextsmsIcon /> Communication Way :{user ? user.communicationway.name : null}
                    </div>
                    <div className="w-100 my-1 mx-3">
                      <ShareIcon /> Channal :{user ? user.chanel.name : null}
                    </div>
                    <div className="w-100 my-1 mx-3">
                      <SatelliteAltIcon /> Campaign :{user ? user.campaign.CampainName : null}
                    </div>
                    <div className="w-100 my-1 mx-3">
                      <HistoryIcon /> Status : {user ? user.leedtype : null}
                    </div>
                    <div className="w-100 my-1 mx-3">
                      <NotesIcon /> Note :{user ? user.notes : null}
                    </div>
                    <div className="w-100 my-1 mx-3">
                      <CalendarMonthIcon /> Creation Date :{' '}
                      {user.updatedAt
                        ? moment(user.updatedAt).format('DD/MM/YYYY h:mm A')
                        : user.createdAt
                          ? moment(user.createdAt).format('DD/MM/YYYY h:mm A')
                          : null}
                    </div>
                  </div>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseleed}
                  className="button-28"
                  style={{ background: '#0F7687', color: 'white' }}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>

            {/* //=============================================================== */}

            {/* //=======================================================================================dialog full screen for all comments to selected leed */}

            <Dialog
              fullScreen
              open={openfullscreen}
              onClose={handleClosefullscreen}
              TransitionComponent={Transition}
              style={{ background: 'black' }}
              className="commentdialog"
            >
              <AppBar
                sx={{ position: 'relative', background: '#0F7687' }}
                className="commentdialog"
              >
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClosefullscreen}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                    Comments ({comments ? comments.length : null})
                  </Typography>
                  <Button autoFocus color="inherit" onClick={handleClosefullscreen}>
                    HOMEWALKERS
                  </Button>
                </Toolbar>
              </AppBar>
              <List>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    background: '',
                  }}
                >
                  {comments
                    ? comments.map((item, index) => {
                        return (
                          <AllCommentsCommponentMainShow key={index} comments={item} user={user} />
                        );
                      })
                    : null}{' '}
                </div>

                <Divider />
              </List>
            </Dialog>

            {/* //===================================================================================================== */}
            <div className="Actionheader">
              <div className="headercommentfont">
                <div className="mx-2 iconsofaction" style={{ color: 'white' }}>
                  Leed Name :{user.name} || USER Name :
                  {userlogin && userlogin.data ? userlogin.data.name : null}
                </div>
                <div
                  className="m-2 iconsofaction"
                  style={{ color: 'white', cursor: 'pointer' }}
                  onClick={() => window.open(`https://wa.me/${user.phone}`, '_blank')}
                >
                  Lead Phone: {user.phone}
                </div>
                <div
                  className="m-2 iconsofaction"
                  style={{ color: 'white', fontSize: '22px', cursor: 'pointer' }}
                  onClick={() => window.open(`https://wa.me/${user.phone}`, '_blank')}
                >
                  <WhatsAppIcon style={{ fontSize: '45px' }} />
                </div>{' '}
              </div>

              {/* //================================================== */}

              <div className="d-flex ">
                <Tooltip title="Leed Preview" arrow>
                  <div
                    className="mx-2 iconsofaction"
                    style={{ color: '#0F7687' }}
                    onClick={handleClickOpenleed}
                  >
                    <VisibilityIcon />
                  </div>
                </Tooltip>

                {userlogin && userlogin.data ? (
                  userlogin.data.role !== 'Sales' ? (
                    <Tooltip title="Edit Leed" arrow>
                      <Link to={`/updateclient/${user._id}`}>
                        <div className="mx-2 iconsofaction" style={{ color: '#0F7687' }}>
                          <EditIcon />
                        </div>
                      </Link>
                    </Tooltip>
                  ) : null
                ) : null}

                <Tooltip title={`All Comments For ${user.name}`} arrow>
                  <div
                    className="mx-2 iconsofaction"
                    style={{ color: '#0F7687' }}
                    onClick={handleClickOpen}
                  >
                    <TextsmsIcon />
                  </div>
                </Tooltip>

                {user?.sales?.userlog?._id === userlogin?.data?._id ? (
                  <Tooltip title={`Stage arrow`}>
                    <Link
                      to={`/updatestage/${user._id}/${user.sales ? user.sales._id : null}`}
                      style={{ textDecoration: 'none' }}
                    >
                      <div className="mx-2 iconsofaction" style={{ color: '#0F7687' }}>
                        <AddCircleIcon />
                      </div>
                    </Link>
                  </Tooltip>
                ) : null}
                {userlogin && userlogin.data ? (
                  userlogin.data.role !== 'Sales' ? (
                    <Tooltip title={`Lead Assigned`}>
                      <Link to={`/LeadAssigned/${user._id}`} style={{ textDecoration: 'none' }}>
                        <div className="mx-2 iconsofaction" style={{ color: '#0F7687' }}>
                          <InfoIcon />
                        </div>
                      </Link>
                    </Tooltip>
                  ) : null
                ) : null}

                {userlogin && userlogin.data ? (
                  userlogin.data.role !== 'Sales' ? (
                    <Tooltip title={`Leads Stages`}>
                      <Link to={`/LeadStages/${user._id}`} style={{ textDecoration: 'none' }}>
                        <div className="mx-2 iconsofaction" style={{ color: '#0F7687' }}>
                          <CachedIcon />
                        </div>
                      </Link>
                    </Tooltip>
                  ) : null
                ) : null}
              </div>
            </div>

            <hr style={{ color: 'white' }} />
            <div className="button-7" style={{ width: '100px', background: '#0F7687' }}>
              First Action
            </div>
            <div>
              {/* الـ Input */}
              <input
                value={firstcomment}
                onChange={onfirstcommentchange}
                className="inputsaddclient"
                type="text"
                id="name"
                name="Note"
                placeholder="Your First Action.."
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  marginBottom: '10px',
                }}
              />

              {/* البوكس اللي هيعرض النص */}
              {firstcomment && (
                <div
                  style={{
                    position: 'fixed',
                    bottom: '10px',
                    right: '20px',
                    backgroundColor: '#007bff',
                    color: '#fff',
                    padding: '10px 15px',
                    borderRadius: '10px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    maxWidth: '450px',
                    fontSize: '14px',
                    cursor: 'text',
                    outline: 'none',
                    zIndex: '1000',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '10px',
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  {/* الأيقونة خارج النص */}
                  <span style={{ fontWeight: 'bold', userSelect: 'none', pointerEvents: 'none' }}>
                    First📩
                  </span>

                  {/* النص القابل للتعديل */}
                  <div
                    contentEditable
                    suppressContentEditableWarning
                    onInput={onPopupfirstcommentchangeChange}
                    style={{
                      flex: 1,
                      outline: 'none',
                      wordBreak: 'break-word',
                      whiteSpace: 'pre-wrap',
                      overflowWrap: 'break-word',
                    }}
                  >
                    {firstcomment}
                  </div>
                </div>
              )}
            </div>
          </div>
          <hr />

          <div>
            <div className="button-7" style={{ background: '#0F7687' }}>
              Next Action
            </div>
            {/* حقل الإدخال */}

            <input
              value={secondcomment}
              onChange={onsecondcommentchange}
              className="inputsaddclient"
              type="text"
              id="name"
              name="Note"
              placeholder="Your First Action.."
            />

            {/* البوب أب اللي بيظهر عند الكتابة */}
            <div>
              {secondcomment && (
                <div
                  style={{
                    position: 'fixed',
                    bottom: '10px',
                    left: '50px',
                    backgroundColor: '#007bff',
                    color: '#fff',
                    padding: '10px 15px',
                    borderRadius: '10px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    maxWidth: '450px',
                    fontSize: '14px',
                    cursor: 'text',
                    outline: 'none',
                    zIndex: '1000',
                    display: 'flex',
                    alignItems: 'flex-end center',
                    gap: '10px',
                  }}
                >
                  {/* الأيقونة خارج النص لكنها بجانبه */}
                  <span style={{ fontWeight: 'bold', userSelect: 'none', pointerEvents: 'none' }}>
                    Second📩
                  </span>

                  {/* النص القابل للتعديل */}
                  <div
                    ref={divRef}
                    contentEditable
                    suppressContentEditableWarning
                    onInput={onPopupChange}
                    onKeyUp={saveCursorPosition}
                    onMouseUp={saveCursorPosition}
                    style={{
                      flex: 1,
                      outline: 'none',
                      wordBreak: 'break-word', // يكسر النص
                      whiteSpace: 'pre-wrap', // يحافظ على المسافات والأسطر
                      overflowWrap: 'break-word', // يمنع خروج النص
                    }}
                  >
                    {secondcomment}
                  </div>
                </div>
              )}
            </div>

            <div style={{ width: '100%', marginTop: '10px' }}>
              {/* //next action  */}
              <div className="d-flex justify-content-between">
                {/* //date and time */}
                <div>
                  <div>
                    <div
                      className="button-7 mx-1"
                      style={{ width: '100px', background: '#0F7687' }}
                    >
                      Date and Time
                    </div>

                    {/* <label style={{color:'white'}} for="dateandtime"> (date and time)</label><br/> */}
                    <DateTimePicker onChange={handleChange} value={valuedate} />
                    {/* <p label style={{color:'white'}}>التاريخ والوقت المحدد: {formattedDate}</p> */}

                    {/* <input  onChange={dateandtimechange} value={startDateTime ? new Date(startDateTime).toISOString().slice(0, 16) : ''}   type="datetime-local" id="birthdaytime" name="birthdaytime"/> */}
                  </div>
                </div>

                {/* //button to add  */}
              </div>

              {/* <div onClick={onsubmitdata} className='button-7 my-3' style={{backgroundColor:'#0F7687',width:'100%',height:'40px'}}><AddIcon/> Add Comment</div> */}
              <div
                onClick={!sendloading ? onsubmitdata : null}
                className="button-7 my-3"
                style={{
                  backgroundColor: '#102dff',
                  width: '100%',
                  height: '40px',
                  pointerEvents: sendloading ? 'none' : 'auto',
                  opacity: sendloading ? 0.6 : 1,
                  cursor: sendloading ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                {sendloading ? (
                  <CircularProgress size={20} style={{ color: 'white' }} />
                ) : (
                  <>
                    <AddIcon /> Add New Comment
                  </>
                )}
              </div>
            </div>
          </div>
          <hr style={{ color: 'white' }} />
          {/* //comments */}
          <div style={{ marginTop: '10px' }}>
            <div className="d-flex justify-content-between">
              <div
                className="button-7"
                style={{ width: '100px', background: '#0F7687', padding: '5px' }}
              >
                Comments ({comments.length})
              </div>
              <br />
              <hr />
              <div onClick={getallactiondata} className="button-18" style={{ width: '100px' }}>
                Refresh <RefreshIcon />
              </div>
            </div>

            {/* //comments data ================================================== */}
            {isReady && comments ? (
              comments.map((item, index) => (
                <CommentsCommponent key={index} comments={item} user={user} />
              ))
            ) : (
              <div
                className="my-3 w-100 d-flex justify-content-center"
                style={{ textAlign: 'center' }}
              >
                {' '}
                <CircularProgress style={{ color: 'royalblue' }} color="white" />
                <div style={{ color: 'white' }}>Loading ...</div>{' '}
              </div> // شاشة تحميل مؤقتة
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* <input className='mx-2 my-1' type='checkbox'  onClick={handleShow} checked={isChecked} onChange={() => setIsChecked(!isChecked)} style={{color:'royalblue',padding:'0',cursor:'pointer'}}/> */}
      {/* <div  className='btn btn-info'><ShareIcon/></div> */}

      {/* <div 
  className='mx-2 my-1'
  onClick={() => {
    handleShow();
    setIsChecked(!isChecked);
  }}
  style={{
    color: '#0F7687',
    padding: '0',
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
    textUnderlineOffset: '3px', // المسافة بين النص والخط
    textDecorationColor: '#0F7687', // لون الخط
    textDecorationThickness: '1px', // سمك الخط
    ':hover': {
      textDecorationThickness: '2px' // يزيد سمك الخط عند hover
    }
  }}
>
  {user.name}

</div> */}

      <Tooltip
        title={
          !isClickable
            ? `You can't access this lead befare ${user?.sales?.name} confirm Recieve`
            : ''
        }
      >
        <div
          className="mx-2 my-1"
          onClick={() => {
            if (!isClickable) return; // 🚫 ممنوع التفاعل

            handleShow();
            setIsChecked(!isChecked);
          }}
          style={{
            color: isClickable ? '#666' : '#888',
            padding: '0',
            cursor: isClickable ? 'pointer' : 'not-allowed',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textDecoration: 'underline',
            textUnderlineOffset: '3px',
            textDecorationColor: '#666',
            textDecorationThickness: '1px',
          }}
        >
          {user.name}
        </div>
      </Tooltip>
    </div>
  );
};
